/**
* 左边菜单
*/
<template>
    <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path"
             unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff"
             active-text-color="#ffd04b">
        <div class="logobox">
            <img class="logoimg" src="../assets/img/logo.png" alt="">
        </div>
        <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
            <template slot="title">
                <i class="iconfont" :class="menu.icon"></i>
                <span>{{ menu.menuname }}</span>
            </template>
            <el-menu-item-group>
                <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
                    <i class="iconfont" :class="chmenu.icon"></i>
                    <span>{{ chmenu.menuname }}</span>
                </el-menu-item>
            </el-menu-item-group>
        </el-submenu>
    </el-menu>
</template>
<script>
import {menu} from '../api/userMG'

export default {
    name: 'leftnav',
    data() {
        return {
            collapsed: false,
            allmenu: []
        }
    },
    // 创建完毕状态(里面是操作)
    created() {
        // 获取图形验证码
        let res = {
            success: true,
            data: [


                {
                    menuid: 190,
                    icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
                    menuname: '大数据',
                    hasThird: null,
                    url: null,
                    menus: [
                        {
                            menuid: 191,
                            icon: 'icon-provider-manage',
                            menuname: '大数据',
                            hasThird: 'N',
                            url: 'bigdata/bigdata',
                            menus: null
                        },
                        {
                            menuid: 270,
                            icon: 'icon-provider-manage',
                            menuname: '大数据浏览记录',
                            hasThird: 'N',
                            url: 'bigdata/bigdatabrowse',
                            menus: null
                        },
                        {
                            menuid: 280,
                            icon: 'icon-provider-manage',
                            menuname: '系统配置',
                            hasThird: 'N',
                            url: 'bigdata/system_config',
                            menus: null
                        }
                    ]
                },
                {
                    menuid: 192,
                    icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
                    menuname: '用户管理',
                    hasThird: null,
                    url: null,
                    menus: [
                        {
                            menuid: 193,
                            icon: 'icon-provider-manage',
                            menuname: '用户管理',
                            hasThird: 'N',
                            url: 'user/user',
                            menus: null
                        }
                    ]
                }
                ,
                {
                    menuid: 194,
                    icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
                    menuname: '品牌管理',
                    hasThird: null,
                    url: null,
                    menus: [
                        {
                            menuid: 195,
                            icon: 'icon-provider-manage',
                            menuname: '品牌分类',
                            hasThird: 'N',
                            url: 'shop/sort',
                            menus: null
                        },
                        {
                            menuid: 196,
                            icon: 'icon-provider-manage',
                            menuname: '品牌列表',
                            hasThird: 'N',
                            url: 'shop/brand',
                            menus: null
                        },
                        {
                            menuid: 197,
                            icon: 'icon-provider-manage',
                            menuname: '产品案例',
                            hasThird: 'N',
                            url: 'shop/product',
                            menus: null
                        },
                        {
                            menuid: 198,
                            icon: 'icon-provider-manage',
                            menuname: '宣传视频',
                            hasThird: 'N',
                            url: 'shop/video',
                            menus: null
                        },
                        {
                            menuid: 300,
                            icon: 'icon-provider-manage',
                            menuname: '品牌浏览记录',
                            hasThird: 'N',
                            url: 'shop/brandbrowse',
                            menus: null
                        },
                        {
                            menuid: 301,
                            icon: 'icon-provider-manage',
                            menuname: '产品浏览记录',
                            hasThird: 'N',
                            url: 'shop/productbrowse',
                            menus: null
                        }

                    ]
                }

                ,
                {
                    menuid: 198,
                    icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
                    menuname: '行业咨询',
                    hasThird: null,
                    url: null,
                    menus: [
                        {
                            menuid: 199,
                            icon: 'icon-provider-manage',
                            menuname: '行业咨询',
                            hasThird: 'N',
                            url: 'service/service',
                            menus: null
                        }
                    ]
                },
                {
                    menuid: 200,
                    icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
                    menuname: '咨询帮助',
                    hasThird: null,
                    url: null,
                    menus: [
                        {
                            menuid: 201,
                            icon: 'icon-provider-manage',
                            menuname: '咨询帮助',
                            hasThird: 'N',
                            url: 'help/help',
                            menus: null
                        }
                    ]
                },
                {
                    menuid: 202,
                    icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
                    menuname: '首页轮播图',
                    hasThird: null,
                    url: null,
                    menus: [
                        {
                            menuid: 203,
                            icon: 'icon-provider-manage',
                            menuname: '首页轮播图',
                            hasThird: 'N',
                            url: 'slide/slide',
                            menus: null
                        }
                    ]
                },
                {
                    menuid: 204,
                    icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
                    menuname: '产品中心',
                    hasThird: null,
                    url: null,
                    menus: [
                        {
                            menuid: 205,
                            icon: 'icon-provider-manage',
                            menuname: '产品中心',
                            hasThird: 'N',
                            url: 'productCenter/productCenter',
                            menus: null
                        }
                    ]
                },
                {
                    menuid: 206,
                    icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
                    menuname: '商务合作',
                    hasThird: null,
                    url: null,
                    menus: [
                        {
                            menuid: 207,
                            icon: 'icon-provider-manage',
                            menuname: '商务合作',
                            hasThird: 'N',
                            url: 'business/business',
                            menus: null
                        }
                    ]
                }

            ],
            msg: 'success'
        }
        this.allmenu = res.data

        // menu(localStorage.getItem('logintoken'))
        //   .then(res => {
        //     console.log(JSON.stringify(res))
        //     if (res.success) {
        //       this.allmenu = res.data
        //     } else {
        //       this.$message.error(res.msg)
        //       return false
        //     }
        //   })
        //   .catch(err => {
        //     this.$message.error('菜单加载失败，请稍后再试！')
        //   })
        // 监听
        this.$root.Bus.$on('toggle', value => {
            this.collapsed = !value
        })
    }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 240px;
    min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
    text-align: left;
}

.el-menu-item-group__title {
    padding: 0px;
}

.el-menu-bg {
    background-color: #1f2d3d !important;
}

.el-menu {
    border: none;
}

.logobox {
    height: 40px;
    line-height: 40px;
    color: #9d9d9d;
    font-size: 20px;
    text-align: center;
    padding: 20px 0px;
}

.logoimg {
    height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue